import image1 from "../assets/products/image-1.png";
import image2 from "../assets/products/image-2.png";
import image3 from "../assets/products/image-3.png";
import image4 from "../assets/products/image-4.png";
import image5 from "../assets/products/image-5.png";

export const products = [
  {
    title: "Yoga Services Business App",
    description:
      "Expand your Yoga Services Business with the numerous solutions offered by this app. Currently under development, this app will provide a comprehensive suite of features designed to elevate your yoga business to new heights.",
    formLink: "https://surveyheart.com/form/68219484aaf08e26a56f30de",
    image: image1,
    youtubeVideoLink: "https://www.youtube.com/embed/mH8BCyWKnc4",
  },
  {
    title: "Fitness Center App",
    description:
      "Boost your Fitness Center Business with the dynamic features offered by this app. Currently under development, this app will deliver an all-in-one platform designed to simplify management, engage members, and take your fitness center to the next level.",
    formLink: "",
    image: image2,
    youtubeVideoLink: "https://www.youtube.com/embed/I7pxNuSJIWc",
  },
  {
    title: "Mental Wellness Services App",
    description:
      "Enhance your Mental Wellness Services with thoughtful solutions from this upcoming app. It will offer features to support client well-being, streamline delivery, and grow your practice with ease.",
    formLink: "",
    image: image3,
    youtubeVideoLink: "https://www.youtube.com/embed/s7heKRXwJKY",
  },
  {
    title: "Business Consultancy & Coaching Services App",
    description:
      "Elevate your Consultancy and Coaching Services with powerful tools from this upcoming app. Designed to streamline client management, deliver coaching programs, and boost business outcomes.",
    formLink: "",
    image: image4,
    youtubeVideoLink: "https://www.youtube.com/embed/Pbu4CNMvOcM",
  },
  {
    title: "Tuition Coaching Business App",
    description:
      "Grow your Tuition Coaching Business with smart solutions from this upcoming app. Designed to manage classes, engage students, and simplify operations for seamless growth.",
    formLink: "",
    image: image5,
    youtubeVideoLink: "https://www.youtube.com/embed/FDrhImkoL0M",
  },
];
